import { Checkbox } from '@chakra-ui/react';

const CheckBox = Checkbox;

export default CheckBox;
